import React, {ReactNode, useRef} from "react";
import styled from "styled-components";
import VideoProgressBar from "./VideoProgressBar";
import VideoTimer from "./VideoTimer";
import PlayButtonSM from "./PlayButtonSM";
import SlideMarkerList from "./SlideMarkerList";
import {IPTSlideEvent} from "../../interfaces/IPTInformation";

const StyledVideoPlayBar = styled.div`
    position: relative;
    text-align: left;
    height: 60px;
    background-color: #393939;
    top: -1px;
    .play-button {
        height: 100%;
        cursor: pointer;
        display: inline-block;
    }
`;

interface IVideoPlayBar {
    currentMsTime: number;
    videoDOM: HTMLVideoElement;
    onCurrentTimeChange: (currentTimeMS: number) => void;
    children?: ReactNode;
    slideEvents: ReadonlyArray<IPTSlideEvent>;
    currentMarkerIndex?: number;
    duration: number;
}


const VideoPlayBar: React.FC<IVideoPlayBar> = (({
                                                    currentMsTime,
                                                    videoDOM,
                                                    onCurrentTimeChange,
                                                    slideEvents,
                                                    currentMarkerIndex,
                                                    duration
                                                }) => {

    const progressBarRef = useRef<HTMLDivElement>(null);

    return (
        <StyledVideoPlayBar>
            <div className={"play-button"}
                 onClick={() => {
                     if (!videoDOM) {
                         return;
                     }
                     videoDOM.paused ? videoDOM.play() : videoDOM.pause();
                 }}>
                <PlayButtonSM isPlaying={videoDOM.paused}/>
            </div>
            <VideoProgressBar ref={progressBarRef}
                              percentage={duration ? ((currentMsTime / 1000) / duration) * 100 : 0}
                              duration={duration}
                              isPlaying={videoDOM.paused}
                              onClick={e => {
                                  const progressBarDiv = progressBarRef.current;
                                  if (!progressBarDiv || !videoDOM) {
                                      return;
                                  }
                                  const {left = 0, width = 1} = progressBarDiv.getBoundingClientRect();
                                  const pos = (e.clientX - left) / (width);
                                  const newCurrentTime = pos * duration;
                                  videoDOM.currentTime = newCurrentTime;
                                  onCurrentTimeChange(newCurrentTime);
                              }}>
                {
                    !isNaN(duration) && duration !== Infinity &&
                    <SlideMarkerList
                        slideEvents={slideEvents}
                        duration={duration}
                        currentMarkerIndex={currentMarkerIndex}
                        onClick={(index, markerCurrentTime) => {
                            videoDOM.currentTime = markerCurrentTime;
                            onCurrentTimeChange(markerCurrentTime);
                        }}/>
                }

            </VideoProgressBar>

            <VideoTimer currentTime={currentMsTime ? currentMsTime / 1000 : 0}
                        duration={duration}/>
        </StyledVideoPlayBar>
    )
});

export default VideoPlayBar;